export default __webpack_public_path__ + "static/media/check2.108fc360.png";